import { isPlatform } from '@ionic/vue';

export function getApiUrl() {
  const isAndroid = isPlatform('android') && !isPlatform('mobileweb');
  if (process.env.VUE_APP_NODE_ENV === 'local')
    return !isAndroid ? 'http://localhost:8100' : 'http://10.0.2.2:8100';

  return process.env.VUE_APP_API_URL;
}

export function isNativeNotWeb() {
  const isNative = isPlatform('android') || isPlatform('ios');
  const isNativeBrowser = isPlatform('mobileweb');

  return isNative && !isNativeBrowser;
}

export function isIosNativeOnly() {
  const isIos = isPlatform('ios');
  const isNativeBrowser = isPlatform('mobileweb');

  return isIos && !isNativeBrowser;
}

export function isAndroidNativeOnly() {
  const isAndroid = isPlatform('android');
  const isNativeBrowser = isPlatform('mobileweb');

  return isAndroid && !isNativeBrowser;
}

/**
 * Check if device is a tablet (iPad or Android tablet)
 * Returns true for tablets even when running in phone compatibility mode
 */
export function isTablet() {
  if (typeof window === 'undefined') return false;

  // Check for iPad in user agent (includes iPadOS 13+ which requests desktop site)
  const isIpadUA = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document;

  // Check Ionic platform
  const isTabletPlatform = isPlatform('ipad') || isPlatform('tablet');

  // Check for tablet screen width (common for tablet detection)
  const screenWidth = window.screen?.width || window.innerWidth;
  const screenHeight = window.screen?.height || window.innerHeight;
  const isTabletSize = Math.min(screenWidth, screenHeight) >= 768;

  return isIpadUA || isTabletPlatform || (isPlatform('ios') && isTabletSize);
}

/**
 * Track a button click with product analytics.
 * @param {string} buttonName - The name of the button clicked
 * @param {string} page - The page where the click occurred
 */
export async function trackButtonClick(buttonName, page) {
  try {
    const { trackNavigationClick } = await import('@/utils/analytics');
    trackNavigationClick({
      label: buttonName,
      page,
      source: 'trackButtonClick',
    });
  } catch (error) {
    console.warn('[Analytics] Failed to track product button click:', error);
  }
}
